import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

const FAQS = [
    {
        q: "Kayseri'de tesisatçı kaç para alır?",
        a: "Su tesisatçısı ücretleri yapılacak işe göre değişir. Basit tıkanıklık açma, su kaçağı tespiti, batarya değişimi gibi işlerde uygun fiyatlı sabit tarife uygularız. İşe başlamadan önce mutlaka net teklif veriyoruz — sürpriz ücret yok. Fiyat öğrenmek için 0505 495 01 78 numaralı çağrı hattımızı arayabilirsiniz.",
    },
    {
        q: "Su tesisatçısı ne iş yapar?",
        a: "Bir su tesisatçısı; bina içi temiz ve pis su tesisatı kurulumu, tıkanıklık açma, su kaçağı tespiti, sıhhi tesisat onarımı, kombi ve petek tamiri, banyo-mutfak armatür montajı ve gizli rezervuar/sifon işlerini yapar. Biz Kayseri'de bu tüm işlemleri 7/24 gerçekleştiriyoruz.",
    },
    {
        q: "Acil tesisatçıya geceleri de ulaşabilir miyim?",
        a: "Evet. 7/24 acil servis hattımız her zaman açıktır. Gece yarısı, hafta sonu ya da resmi tatil fark etmeden Kayseri içi ortalama 30 dakika içinde adresinize ulaşırız.",
    },
    {
        q: "Su kaçağı tespiti yaparken duvar kırıyor musunuz?",
        a: "Hayır. Modern termal kamera ve akustik dinleme cihazlarıyla kaçağın tam noktasını tespit ediyoruz. Sadece gerekirse ve gerekli olan minimum alanı açıyoruz; gereksiz kırma-dökme yapmayız.",
    },
    {
        q: "Hangi bölgelere tesisatçı hizmeti veriyorsunuz?",
        a: "Kayseri merkez (Melikgazi, Kocasinan, Talas) başta olmak üzere İncesu, Hacılar, Develi, Yahyalı, Bünyan, Pınarbaşı, Tomarza, Sarıoğlan, Akkışla, Felahiye, Özvatan, Sarız ve Yeşilhisar dahil olmak üzere tüm Kayseri ilçelerine hizmet veriyoruz.",
    },
    {
        q: "Yapılan işin garantisi var mı?",
        a: "Evet. Yaptığımız tüm tesisat işleri işçilik garantilidir. Aynı sorun garanti süresinde tekrar ederse ücretsiz tekrar gelir, onarımı yenileriz.",
    },
    {
        q: "Kombim sürekli arıza veriyor, tesisatçı mı yoksa servis mi çağırmalıyım?",
        a: "Kombinizin cihaz arızası yetkili servis kapsamındadır. Ancak peteklerinizde sıcaklık düşüklüğü, hava alma, kireç temizliği, su basıncı sorunları gibi tesisat kaynaklı sorunlar için bizi arayabilirsiniz. Genellikle sorun cihazda değil tesisatta olur.",
    },
];

const Item = ({ faq, isOpen, onClick, idx }) => (
    <motion.div
        layout
        data-testid={`faq-item-${idx}`}
        className="border-b border-slate-200 last:border-b-0"
    >
        <button
            onClick={onClick}
            data-testid={`faq-toggle-${idx}`}
            className="w-full flex items-center justify-between gap-4 py-5 text-left group"
        >
            <span className="font-bold text-slate-900 text-base sm:text-lg group-hover:text-[#0055FF] transition-colors">
                {faq.q}
            </span>
            <span className="flex-shrink-0 w-9 h-9 rounded-full bg-slate-100 group-hover:bg-[#E5EDFF] flex items-center justify-center transition-colors">
                {isOpen ? (
                    <Minus className="w-4 h-4 text-[#0055FF]" strokeWidth={3} />
                ) : (
                    <Plus className="w-4 h-4 text-slate-700 group-hover:text-[#0055FF]" strokeWidth={3} />
                )}
            </span>
        </button>
        <AnimatePresence initial={false}>
            {isOpen && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                >
                    <p className="pb-5 pr-12 text-slate-600 leading-relaxed text-[15px]">
                        {faq.a}
                    </p>
                </motion.div>
            )}
        </AnimatePresence>
    </motion.div>
);

export const FAQ = () => {
    const [open, setOpen] = useState(0);
    return (
        <section
            id="sss"
            data-testid="faq-section"
            className="relative py-20 sm:py-28 bg-[#F8FAFC]"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0055FF]">
                        Sık Sorulan Sorular
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Kayseri tesisatçı <span className="text-[#0055FF]">SSS</span>
                    </h2>
                </div>
                <div className="rounded-2xl border border-slate-200 bg-white px-5 sm:px-8">
                    {FAQS.map((faq, idx) => (
                        <Item
                            key={idx}
                            faq={faq}
                            idx={idx}
                            isOpen={open === idx}
                            onClick={() => setOpen(open === idx ? -1 : idx)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
export { FAQS };
